'use client';

import { useEffect } from 'react';
import { reportError } from '@/lib/error-reporting';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, {
      context: 'render:global-error',
      extra: { digest: error.digest ?? null },
    });
  }, [error]);

  // No web fonts on purpose. This page used to link Josefin Sans + Lato from
  // Google, but nothing here names either family: every font-family is
  // var(--font-sans), which is undefined outside the root layout (its <html>
  // carries the font variables), so the page has always rendered in the
  // browser's default face (checked in WebKit 2026-09-30, identical with and
  // without the faces). Importing self-hosted faces instead would add a
  // global-error stylesheet that Next preloads on EVERY page, unused.
  return (
    <html lang="es">
      <body
        style={{
          padding: 'var(--space-3xl)',
          maxWidth: 480,
          margin: `var(--space-5xl) auto`,
          fontFamily: 'var(--font-sans)',
          textAlign: 'center',
          background: 'var(--bg)',
          color: 'var(--ink-2)',
        }}
      >
        <h2 style={{ fontFamily: 'var(--font-sans)', fontSize: 20, marginBottom: 'var(--space-md)' }}>
          La aplicación no se pudo cargar.
        </h2>
        <p style={{ fontSize: 14, color: 'var(--ink-3)', marginBottom: 'var(--space-2xl)' }}>
          Ya quedó registrado. Recarga la página.
        </p>
        <button type="button"
          onClick={reset}
          style={{
            padding: `var(--space-sm) var(--space-xl)`,
            background: 'var(--accent)',
            color: 'var(--bg)',
            border: 'none',
            borderRadius: 'var(--r-md)',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            fontFamily: 'var(--font-sans)',
          }}
        >
          Reintentar
        </button>
      </body>
    </html>
  );
}
